import axios from "axios";
import qs from "qs";

// 学生签到状态
export enum StuSignInStatus {
    Idle = 0, // 未签到
    Done = 1, // 出勤
    // Absent = 2, // 缺勤
    Late = 3, // 迟到
    Leave = 4 // 早退
}

// 签到方式
export enum SignType {
    QrCode = 0, // 二维码
    Number = 1, // 数字
    Normal = 2, // 普通
    Live = 3 //直播
}

// 签到开启状态
export enum SignStatus {
    Idle = 0, // 未开启
    InProgress = 1, // 进行中
    Done = 2 // 结束
}

// 参与状态
export enum StuSignStatus {
    Idle = "1", // 未参与
    Done = "2", // 已参与
    Timeout = "3" // 已结束
}

export const SignStatusMap: { [key: string]: string } = {
    [SignStatus.Idle]: "未开始",
    [SignStatus.InProgress]: "进行中",
    [SignStatus.Done]: "已结束"
};

export const StuSignStatusMap = {
    [StuSignStatus.Idle]: "未参与",
    [StuSignStatus.Done]: "已参与",
    [StuSignStatus.Timeout]: "已结束"
};

export interface StuSignInListItem {
    id: number;
    title: string;
    weekTimeId: number;
    type: SignType;
    refreshTime: number;
    validityTime: string;
    startTime: string;
    endTime: string;
    code: string;
    signStatus: StuSignStatus;
    signTime: string; // 签到时间
}

/**
 * 学生签到列表
 * @param weekTimeId
 */
export function getStuSignInList(weekTimeId: number) {
    return axios
        .post<SuccessData<StuSignInListItem[]>>(
            "/student/signIn/getStuSignInList",
            qs.stringify({ weekTimeId })
        )
        .then(res => res.data.data);
}

export interface SignInInfo {
    studentNo: string;
    signStatus: StuSignInStatus;
    signInTime: string; // 签到时间
    signInModel: {
        type: SignType;
        status: SignStatus;
        title: string;
        startTime: string;
        endTime: string;
        validityTime?: string;
    };
    title: string;
}

/**
 * 学生签到详细
 * @param signInId
 */
export function getSignInInfo(signInId: number) {
    return axios
        .post<SuccessData<SignInInfo>>(
            "/student/signIn/getSignInInfo",
            qs.stringify({ signInId })
        )
        .then(res => res.data.data);
}

/**
 * 获取直播签到信息
 * @param signInId
 */
export function getOnlineSignInInfo(signInId: number) {
    return axios
        .post<SuccessData<SignInInfo>>(
            "/student/signIn/getOnlineSignInInfo",
            qs.stringify({ signInId })
        )
        .then(res => res.data.data);
}

/**
 * 学生签到接口
 * @param signInId
 * @param code
 */
export function InTheSign(signInId: number, code: string) {
    return axios.post<SuccessData<SignInInfo>>(
        "/student/signIn/InTheSign",
        qs.stringify({ signInId, code })
    );
}
